import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'tonnagePipe' })
export class TonnagePipe implements PipeTransform {

    constructor(private currencyPipe: CurrencyPipe) {}

    transform(value: any, currencyCode?: string, locale?: any): string {
        if (value != undefined) {
            let output = this.currencyPipe.transform(value, currencyCode, 'symbol', '1.2-2', locale);
            output= output.replace('€', '');
            return output.replace(/,[\d]*/, '');
        } else {
            return 'NA';
        }
    }
}
